import styled from '@emotion/styled';
import { ReactComponent as Check } from '../assets/check.svg';

interface Props {
  foregroundColor: string;
  backgroundColor: string;
}

const CheckIcon = (props: Props) => {
  return (
    <Container {...props}>
      <Check />
    </Container>
  );
};

export default CheckIcon;

const Container = styled.div<Props>`
  border-radius: 10px;
  width: 20px;
  height: 20px;
  background-color: ${({ backgroundColor }) => backgroundColor};
  color: ${({ foregroundColor }) => foregroundColor};
`;
